import React, { useState, useEffect } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  const { currentUser } = useAuth();

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    
    // If user is logged in and hasn't explicitly accepted cookies, auto-set consent
    // (By logging in, user implicitly agrees to use cookies as stated in Privacy Policy)
    if (currentUser && !cookieConsent) {
      localStorage.setItem('cookieConsent', 'accepted');
      localStorage.setItem('cookieConsentDate', new Date().toISOString());
      setShow(false);
    } else if (!cookieConsent) {
      // Only show banner if user is not logged in and hasn't accepted
      setShow(true);
    }
  }, [currentUser]);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setShow(false);
  };

  if (!show) return null;

  return (
    <Alert 
      variant="info" 
      className="cookie-consent-banner"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1050,
        margin: 0,
        borderRadius: 0,
        borderTop: '2px solid #0d6efd',
        boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.1)'
      }}
    >
      <div className="container">
        <div className="d-flex flex-column flex-md-row align-items-center justify-content-between">
          <div className="mb-3 mb-md-0 me-md-3 flex-grow-1">
            <strong className="d-block mb-1">
              <i className="bi bi-cookie me-2"></i>We use cookies
            </strong>
            <small className="text-muted">
              We use cookies to enhance your browsing experience and personalize content. 
              By clicking "Accept", you consent to our use of cookies. 
              <a href="/privacy" className="text-decoration-none ms-1">Learn more</a>
            </small>
          </div>
          <div className="d-flex gap-2">
            <Button 
              variant="primary" 
              size="sm"
              onClick={handleAccept}
            >
              Accept
            </Button>
          </div>
        </div>
      </div>
    </Alert>
  );
}

